import React, { useState, useEffect, useCallback } from 'react';

// Arayüz ile sunucu aynı adresten servis edilir (server/server.py).
const SERVER = "";

const sessionExpired = () => {
  localStorage.removeItem('app_token');
  window.location.href = '/';
};

const HOURS = [
  "08:40", "09:40", "10:40", "11:40", "12:40",
  "13:40", "14:40", "15:40", "16:40", "17:40"
];

const FACULTIES = [
  "ScOLa", "AB1 - Mühendislik", "AB2 - İşletme", "AB3 - Hukuk", "AB4 - Mimarlık"
];

const ROOMS = {
  "ScOLa": ["128A","128B","128C","129A","129B","130A","130B","230A","231A","231B","232A","232B","326B","326C","326D","326E","327A","327B"],
  "AB1 - Mühendislik": ["232A","232B","233A","233B","238A","238B","240A","240B","241A","241B","245A","245B","246A","246B","407A","407B","408A","408B","409A","409B","412A","412B","413A","413B","414A","414B","509A","509B","510A","510B","511A","511B"],
  "AB2 - İşletme": ["101A","101B","102A","102B","103A","103B","112A","113A","114A","115A","B42A","B43A","B44A","B45A","B46A","B47A","G01A","G01B","G02A","G02B","G03A","G03B","G12A","G13A","G14A","G15A"],
  "AB3 - Hukuk": ["330A","330B","339A","339B","347A","347B","348A","348B","349A","349B","349C","349D","349E"],
  "AB4 - Mimarlık": ["118","119","201","202","203","204","205","206","B114","B115","B116","B117","B227","B229","B303","B304","B305","B306"]
};

const FACULTY_GIDS = {
  "ScOLa": 1059, "AB1 - Mühendislik": 948, "AB2 - İşletme": 994,
  "AB3 - Hukuk": 1058, "AB4 - Mimarlık": 5547,
};

const ROOM_EIDS = {
  "ScOLa": {"128A":4003,"128B":4004,"128C":4005,"129A":4006,"129B":4007,"130A":4008,"130B":4009,"230A":4014,"231A":4012,"231B":4013,"232A":4010,"232B":4011,"326B":4236,"326C":4237,"326D":4238,"326E":4239,"327A":27280,"327B":4240},
  "AB1 - Mühendislik": {"232A":3764,"232B":3765,"233A":3766,"233B":3767,"238A":3768,"238B":3769,"240A":3770,"240B":3771,"241A":3772,"241B":3773,"245A":3774,"245B":3775,"246A":3776,"246B":3777,"407A":3778,"407B":3779,"408A":3780,"408B":3781,"409A":27271,"409B":27272,"412A":3782,"412B":3783,"413A":3784,"413B":3785,"414A":3786,"414B":3787,"509A":3788,"509B":3789,"510A":27273,"510B":27274,"511A":3792,"511B":3793},
  "AB2 - İşletme": {"101A":3814,"101B":3815,"102A":3812,"102B":3813,"103A":3810,"103B":3811,"112A":3819,"113A":3816,"114A":3817,"115A":3818,"B42A":3794,"B43A":3795,"B44A":3796,"B45A":3797,"B46A":3798,"B47A":3799,"G01A":3800,"G01B":3801,"G02A":3802,"G02B":3803,"G12A":3806,"G13A":3807,"G14A":3808,"G15A":3809},
  "AB3 - Hukuk": {"330A":3997,"330B":3998,"339A":3995,"339B":3996,"347A":3999,"347B":4000,"348A":4001,"348B":4002,"349A":27276,"349B":25635,"349C":27277,"349D":27278,"349E":27279},
  "AB4 - Mimarlık": {"118":18892,"119":18893,"201":18882,"202":18883,"203":18885,"204":18887,"205":18888,"206":18889,"B114":27284,"B115":27285,"B116":18890,"B117":18897,"B227":27282,"B229":27283,"B303":18898,"B304":18899,"B305":18900,"B306":27281},
};

const getToday = () => {
  const now = new Date();
  return new Date(now.getTime() + 3 * 60 * 60 * 1000).toISOString().split("T")[0];
};

const getTomorrow = () => {
  const now = new Date();
  return new Date(now.getTime() + 3 * 60 * 60 * 1000 + 86400000).toISOString().split("T")[0];
};

function getConsecutiveStarts(slots, eid, sure) {
  const odaSlots = slots
    .filter(s => s.itemId === eid && !s.className)
    .sort((a, b) => a.start.localeCompare(b.start));

  const musait = [];
  const n = odaSlots.length;
  for (let i = 0; i < n; i++) {
    if (i + sure > n) break;
    let ok = true;
    for (let j = 1; j < sure; j++) {
      const t1 = new Date(odaSlots[i + j - 1].start).getTime();
      const t2 = new Date(odaSlots[i + j].start).getTime();
      if (t2 - t1 !== 3600000) { ok = false; break; }
    }
    if (ok) musait.push(odaSlots[i].start.substring(11, 16));
  }
  return musait;
}

function getMusaitOdalar(slots, fakulte, sure) {
  return ROOMS[fakulte].filter(oda => {
    const eid = ROOM_EIDS[fakulte]?.[oda];
    return eid && getConsecutiveStarts(slots, eid, sure).length > 0;
  });
}

export default function Home() {
  const today    = getToday();
  const tomorrow = getTomorrow();

  const [tarih, setTarih]       = useState(tomorrow);
  const [sure, setSure]         = useState(3);
  const [fakulte, setFakulte]   = useState('');
  const [oda, setOda]           = useState('');
  const [saat, setSaat]         = useState(HOURS[0]);
  const [loading, setLoading]   = useState(false);
  const [fetching, setFetching] = useState(false);
  const [status, setStatus]     = useState('');
  const [statusColor, setStatusColor] = useState('#888');

  const [slotsCache, setSlotsCache]           = useState({});
  const [musaitFakulteler, setMusaitFakulteler] = useState([]);
  const [musaitOdalar, setMusaitOdalar]         = useState([]);
  const [musaitSaatler, setMusaitSaatler]       = useState([]);

  const fetchSlots = useCallback(async (selectedTarih, odaSonrasi = false) => {
    const appToken = localStorage.getItem('app_token');
    if (!appToken) return;

    setFetching(true);
    setMusaitFakulteler([]);
    setMusaitOdalar([]);
    setMusaitSaatler([]);
    setFakulte('');
    setOda('');
    setStatus('Müsait odalar yükleniyor...');
    setStatusColor('#e8ff5a');

    try {
      const results = await Promise.all(
        FACULTIES.map(async fak => {
          const gid = FACULTY_GIDS[fak];
          const res = await fetch(`${SERVER}/slots`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'x-app-token': appToken },
            body: JSON.stringify({ tarih: selectedTarih, gid }),
          });
          if (res.status === 401) throw new Error('session_expired');
          const data = await res.json();
          return { gid, slots: data.slots || [] };
        })
      );

      const newCache = {};
      results.forEach(({ gid, slots }) => { newCache[gid] = slots; });
      setSlotsCache(newCache);
      if (!odaSonrasi) {
        setStatus('Müsait odalar yüklendi.');
        setStatusColor('#4ade80');
      }
    } catch (e) {
      if (e.message === 'session_expired') { sessionExpired(); return; }
      setStatus('Slot yükleme hatası!');
      setStatusColor('#f87171');
    } finally {
      setFetching(false);
    }
  }, []);

  useEffect(() => { fetchSlots(tarih); }, [tarih]);

  useEffect(() => {
      if (Object.keys(slotsCache).length === 0) return;

      const musait = FACULTIES.filter(fak => {
        const gid   = FACULTY_GIDS[fak];
        const slots = slotsCache[gid] || [];
        return getMusaitOdalar(slots, fak, sure).length > 0;
      });

      setMusaitFakulteler(musait);

      if (musait.length === 0) {
        setFakulte(''); setOda('');
        setMusaitOdalar([]); setMusaitSaatler([]);
        return;
      }

      // Mevcut fakülte hala müsaitse koru
      if (fakulte && musait.includes(fakulte)) {
        // Mevcut odayı kontrol et
        const gid    = FACULTY_GIDS[fakulte];
        const slots  = slotsCache[gid] || [];
        const odalar = getMusaitOdalar(slots, fakulte, sure);
        setMusaitOdalar(odalar);

        if (oda && odalar.includes(oda)) {
          // Oda da müsaitse sadece saatleri güncelle, oda değişmesin
          const eid     = ROOM_EIDS[fakulte]?.[oda];
          const saatler = getConsecutiveStarts(slots, eid, sure);
          setMusaitSaatler(saatler);
          if (!saatler.includes(saat) && saatler.length > 0) setSaat(saatler[0]);
        } else {
          setOda(odalar[0] || '');
        }
      } else {
        setFakulte(musait[0]);
      }
    }, [slotsCache, sure]);

  useEffect(() => {
      if (!fakulte) { setMusaitOdalar([]); setOda(''); return; }
      const gid    = FACULTY_GIDS[fakulte];
      const slots  = slotsCache[gid] || [];
      const odalar = getMusaitOdalar(slots, fakulte, sure);
      setMusaitOdalar(odalar);
      // Mevcut oda hala müsaitse koru, değilse ilkini seç
      setOda(prev => odalar.includes(prev) ? prev : (odalar[0] || ''));
    }, [fakulte, slotsCache, sure]);

  useEffect(() => {
      if (!fakulte || !oda) { setMusaitSaatler([]); return; }
      const gid     = FACULTY_GIDS[fakulte];
      const eid     = ROOM_EIDS[fakulte]?.[oda];
      const slots   = slotsCache[gid] || [];
      const saatler = getConsecutiveStarts(slots, eid, sure);
      setMusaitSaatler(saatler);
      setSaat(prev => saatler.includes(prev) ? prev : (saatler[0] || HOURS[0]));
    }, [oda, fakulte, slotsCache, sure]);

  const getBitisStr = () => {
    const [h, m] = saat.split(":").map(Number);
    const total  = h * 60 + m + sure * 60;
    return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
  };

  const handleRezervation = async () => {
    const eid = ROOM_EIDS[fakulte]?.[oda];
    const gid = FACULTY_GIDS[fakulte];
    if (!eid || !gid) { alert('Oda bulunamadı!'); return; }

    const appToken = localStorage.getItem('app_token');
    if (!appToken) { alert('Önce login yapın!'); return; }

    setLoading(true);
    setStatus('Rezervasyon yapılıyor...');
    setStatusColor('#e8ff5a');

    try {
      const response = await fetch(`${SERVER}/rezervasyon`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-app-token': appToken },
        body: JSON.stringify({ eid, gid, saat, tarih, sure }),
      });
      if (response.status === 401) { sessionExpired(); return; }
      const result = await response.json();
      if (result.success) {
        fetchSlots(tarih, true);
        setStatus(`✓ ${result.message}`);
        setStatusColor('#4ade80');
      } else {
        const temizMesaj = result.message.replace(/<[^>]*>/g, '');
        setStatus(`✗ ${temizMesaj}`);
        setStatusColor('#f87171');
      }
    } catch (e) {
      setStatus('Sunucuya bağlanılamadı!');
      setStatusColor('#f87171');
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = fetching || loading;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>[ OzU Room Reserver ]</h1>
      <p style={styles.subtitle}>Özyeğin Üniversitesi · Rezervasyon Botu</p>

      {/* Tarih */}
      <div style={styles.card}>
        <p style={styles.sectionTitle}>TARİH</p>
        <div style={styles.row}>
          {[["Bugün", today], ["Yarın", tomorrow]].map(([label, val]) => (
            <button
              key={val}
              style={{...styles.chip, ...(tarih === val ? styles.chipActive : {})}}
              onClick={() => !isDisabled && setTarih(val)}
            >
              {label}
            </button>
          ))}
          {fetching && <span style={{color:'#e8ff5a', fontSize:'12px', alignSelf:'center'}}>Yükleniyor...</span>}
        </div>
      </div>

      {/* Süre */}
      <div style={styles.card}>
        <p style={styles.sectionTitle}>SÜRE</p>
        <div style={styles.row}>
          {[1, 2, 3].map(s => (
            <button
              key={s}
              style={{...styles.chip, ...(sure === s ? styles.chipActive : {}), opacity: isDisabled ? 0.5 : 1}}
              onClick={() => !isDisabled && setSure(s)}
            >
              {s} Saat
            </button>
          ))}
        </div>
      </div>

      {/* Fakülte */}
      <div style={styles.card}>
        <p style={styles.sectionTitle}>FAKÜLTe</p>
        <select
          style={{...styles.select, opacity: isDisabled ? 0.5 : 1}}
          value={fakulte}
          onChange={e => !isDisabled && setFakulte(e.target.value)}
          disabled={isDisabled || musaitFakulteler.length === 0}
        >
          {musaitFakulteler.length === 0
            ? <option value="">Müsait fakülte yok</option>
            : musaitFakulteler.map(f => <option key={f} value={f}>{f}</option>)
          }
        </select>
      </div>

      {/* Oda */}
      <div style={styles.card}>
        <p style={styles.sectionTitle}>ODA</p>
        <select
          style={{...styles.select, opacity: isDisabled ? 0.5 : 1}}
          value={oda}
          onChange={e => !isDisabled && setOda(e.target.value)}
          disabled={isDisabled || musaitOdalar.length === 0}
        >
          {musaitOdalar.length === 0
            ? <option value="">Müsait oda yok</option>
            : musaitOdalar.map(r => <option key={r} value={r}>{r}</option>)
          }
        </select>
      </div>

      {/* Saat */}
      <div style={styles.card}>
        <p style={styles.sectionTitle}>BAŞLANGIÇ SAATİ</p>
        <div style={styles.row}>
          {HOURS.map(h => {
            const aktif = musaitSaatler.includes(h);
            return (
              <button
                key={h}
                style={{
                  ...styles.chip,
                  ...(saat === h && aktif ? styles.chipActive : {}),
                  ...(!aktif ? styles.chipDisabled : {}),
                }}
                onClick={() => aktif && !isDisabled && setSaat(h)}
                disabled={!aktif || isDisabled}
              >
                {h}
              </button>
            );
          })}
        </div>
        {oda && <p style={styles.bitis}>→ {saat} – {getBitisStr()} arası</p>}
      </div>

      {/* Buton */}
      <button
        style={{...styles.btn, opacity: (loading || !oda) ? 0.6 : 1}}
        onClick={handleRezervation}
        disabled={loading || !oda}
      >
        {loading ? 'Rezervasyon yapılıyor...' : '[ REZERVE ET ]'}
      </button>

      {status && <p style={{...styles.status, color: statusColor}}>{status}</p>}
    </div>
  );
}

const styles = {
  container: { maxWidth: '600px', margin: '0 auto', padding: '32px 24px' },
  title:    { fontSize: '24px', fontWeight: 'bold', color: '#e8ff5a', marginBottom: '4px' },
  subtitle: { fontSize: '12px', color: '#888', marginBottom: '24px' },
  card: {
    backgroundColor: '#1a1a1a', borderRadius: '8px',
    padding: '16px', border: '1px solid #2a2a2a', marginBottom: '12px',
  },
  sectionTitle: { color: '#e8ff5a', fontSize: '11px', fontWeight: 'bold', marginBottom: '10px' },
  row:  { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  chip: {
    padding: '6px 12px', borderRadius: '4px', border: '1px solid #2a2a2a',
    backgroundColor: '#0f0f0f', color: '#f0f0f0', fontSize: '12px',
    fontFamily: 'Courier New', cursor: 'pointer',
  },
  chipActive:   { backgroundColor: '#e8ff5a', borderColor: '#e8ff5a', color: '#0f0f0f', fontWeight: 'bold' },
  chipDisabled: { backgroundColor: '#0f0f0f', borderColor: '#1e1e1e', color: '#444', cursor: 'default', opacity: 0.4 },
  select: {
    backgroundColor: '#0f0f0f', color: '#f0f0f0', padding: '10px',
    borderRadius: '4px', border: '1px solid #2a2a2a', fontSize: '14px',
    fontFamily: 'Courier New', width: '100%', outline: 'none',
  },
  bitis:  { color: '#888', fontSize: '12px', marginTop: '8px' },
  btn: {
    backgroundColor: '#e8ff5a', color: '#0f0f0f', padding: '16px',
    borderRadius: '4px', border: 'none', fontWeight: 'bold', fontSize: '16px',
    fontFamily: 'Courier New', cursor: 'pointer', width: '100%', marginBottom: '12px',
  },
  status: { fontSize: '13px', textAlign: 'center' },
};